import React from 'react'

import { FlexBox, useScreenClass } from '@vp/swan'

import { useProject } from '../../../root/contexts/ProjectContext'
import RemoveProjectButton from './RemoveProjectButton'
import SizeChartFlyoutLink from '../SizeChart/SizeChartFlyoutLink'

const ProjectTools: React.FC = () => {
  const { isSizedGood, sizeFitKey, projectCount, projectNumber } = useProject()
  const screenClass = useScreenClass()

  if (isSizedGood || projectCount > 1) {
    return (
      <FlexBox className="work-tools" flexWrap="wrap" justifyContent={screenClass === 'xs' ? 'left' : 'end'} alignItems="baseline">
        {isSizedGood && !sizeFitKey && <SizeChartFlyoutLink />}
        {projectCount > 1 && projectNumber !== 1 && <RemoveProjectButton />}
      </FlexBox>
    )
  }
  return <></>
}

export default ProjectTools
